__turbopack_context__.v({
  "backgroundImage": "CategoryBannerGrid-module-scss-module__SQlriq__backgroundImage",
  "backgroundImageWrapper": "CategoryBannerGrid-module-scss-module__SQlriq__backgroundImageWrapper",
  "grid": "CategoryBannerGrid-module-scss-module__SQlriq__grid",
  "hasPadding": "CategoryBannerGrid-module-scss-module__SQlriq__hasPadding",
  "section": "CategoryBannerGrid-module-scss-module__SQlriq__section",
  "slide": "CategoryBannerGrid-module-scss-module__SQlriq__slide",
  "wrapper": "CategoryBannerGrid-module-scss-module__SQlriq__wrapper",
});
